import {
  fetchNotificationsFailureActionCreator,
  fetchNotificationsRequestActionCreator,
  fetchNotificationsSuccessActionCreator,
  markNotificationAsReadFailureActionCreator,
  markNotificationAsReadRequestActionCreator,
  markNotificationAsReadSuccessActionCreator,
  notificationRecievedActionCreator,
  resetUnreadCountActionCreator,
  resetNotificationsActionCreator,
} from './notifications.actionCreators';
import API from '../../API';

export const fetchNotifications = (page = 1) => {
  return async dispatch => {
    dispatch(fetchNotificationsRequestActionCreator());
    return await API.get('/notifications', { page })
      .then(resp => {
        dispatch(fetchNotificationsSuccessActionCreator(resp));

        return resp;
      })
      .catch(err => {
        dispatch(fetchNotificationsFailureActionCreator(err));
        throw err;
      });
  };
};

export const notificationRecieved = notification => {
  return notificationRecievedActionCreator(notification);
};

export const markNotificationAsRead = notificationId => {
  return async dispatch => {
    dispatch(markNotificationAsReadRequestActionCreator());
    return await API.post(`/notifications/mark/read/${notificationId}`)
      .then(resp => {
        dispatch(markNotificationAsReadSuccessActionCreator(resp));

        return resp;
      })
      .catch(err => {
        dispatch(markNotificationAsReadFailureActionCreator(err));
        throw err;
      });
  };
};

export const resetUnreadCount = () => {
  return resetUnreadCountActionCreator();
};

export const resetNotifications = () => {
  return resetNotificationsActionCreator();
};
